module.exports = __webpack_public_path__ + "static/img/pic6.bd480e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic6.png
// module id = ekkI
// module chunks = 1